export default "/static/images/tuut_2.png?aa0faf328c131c2fe8bdd41d4ad59935";